"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCategoriesStore = void 0;
const pinia_1 = require("pinia");
const core_1 = require("@vueuse/core");
const Categories_1 = __importDefault(require("../src/api/Categories"));
const get_1 = __importDefault(require("lodash/get"));
exports.useCategoriesStore = (0, pinia_1.defineStore)('categories', {
    state: () => {
        return {
            categories: (0, core_1.useStorage)('categories', []),
        };
    },
    actions: {
        fetchCategories() {
            return __awaiter(this, void 0, void 0, function* () {
                return Categories_1.default.fetchCategories().then(response => {
                    this.$patch({
                        categories: (0, get_1.default)(response, 'data.data'),
                    });
                    return response;
                });
            });
        },
    }
});
